import { SALES_SEAT, SERVICE_SEAT } from 'self-service-api/constants/UnitNames';
import { useCurrencyCodeUnitToDisplay, useDisplayedCurrencyCode } from '../../../hooks/useCurrencies';
import { useAppSelector } from '../../../reducers';
import { includedCoreSeatsQuantityForProductVersionSelector, includedSeatQuantityBySkuIdSelector } from '../../../selectors/ProductsSelectors';
import { IncludedSeatsDisplay } from '../../../v2/components/merch-card/seats-display/IncludedSeatsDisplay';
import { useAdditionalCoreSeatPrice, useShowAdditionalSeatsPriceSubtext, useShowIncludedSeats } from './useSeatsDisplay';
import { jsx as _jsx } from "react/jsx-runtime";
export const IncludedSeatsDisplayContainerV1 = ({
  skuId
}) => {
  const includedCoreSeats = useAppSelector(state => {
    return includedCoreSeatsQuantityForProductVersionSelector(state, {
      productVersionSkuId: skuId
    });
  });
  const includedSalesSeats = useAppSelector(state => {
    return includedSeatQuantityBySkuIdSelector(state, {
      skuId,
      seatUnitName: SALES_SEAT
    });
  });
  const includedServiceSeats = useAppSelector(state => {
    return includedSeatQuantityBySkuIdSelector(state, {
      skuId,
      seatUnitName: SERVICE_SEAT
    });
  });
  const includedCommerceSeats = useAppSelector(state => {
    return includedSeatQuantityBySkuIdSelector(state, {
      skuId,
      seatUnitName: 'COMMERCE_SEAT'
    });
  });
  const currencyCode = useDisplayedCurrencyCode();
  const currencyCodeUnit = useCurrencyCodeUnitToDisplay();
  const showIncludedSeats = useShowIncludedSeats({
    skuId
  });
  const showAdditionalSeatsPriceSubtext = useShowAdditionalSeatsPriceSubtext({
    skuId
  });
  const {
    additionalCoreSeatsPrice
  } = useAdditionalCoreSeatPrice({
    skuId
  });
  return /*#__PURE__*/_jsx(IncludedSeatsDisplay, {
    includedCoreSeats: includedCoreSeats,
    includedSalesSeats: includedSalesSeats,
    includedServiceSeats: includedServiceSeats,
    includedCommerceSeats: includedCommerceSeats,
    showIncludedSeats: showIncludedSeats,
    showAdditionalSeatsPriceSubtext: showAdditionalSeatsPriceSubtext,
    additionalCoreSeatsPrice: additionalCoreSeatsPrice,
    currencyCode: currencyCode,
    currencyCodeUnit: currencyCodeUnit
  });
};